import { gql } from "@apollo/client"

const GET_AUDIT_LOG_SUMMARY = gql`
  query auditLogSummary($eventId: ID!) {
    event(id: $eventId) {
			id
			
			auditLogSummary {
				total
				type_quantities {
          id
					code
					description
					qty
				}
			}
		}
	}
`

export { GET_AUDIT_LOG_SUMMARY }